import React from 'react'

import cn from '../../../../commons/src/libs/class-names'
import {mapChildrenWithFragments} from '../../../../commons/src/services/react-children'

import {CommonProps, Overwrite} from '../../../../commons/src/types'

import Logo from '../logo'

import NavigationLink from './NavigationLink'

type Props = Overwrite<
  CommonProps<'div'>,
  {
    logo: React.ReactElement<React.ComponentProps<typeof Logo>>
    navigationItemsTop: React.ReactNode
    navigationItemsBottom: React.ReactNode
    children: React.ReactNode
    collapse?: boolean
  }
>

const NavigationLayout = ({
  className,
  logo,
  navigationItemsTop,
  navigationItemsBottom,
  children,
  collapse = false,
  ...props
}: Props) => (
  <div {...props} className={cn('NavigationLayout', {collapse}, className)}>
    <aside className="NavigationLayout__aside">
      <div className="NavigationLayout__logo">{React.cloneElement(logo, {collapse})}</div>
      <div className="NavigationLayout__scrollWrapper">
        <nav className="NavigationLayout__navigation">
          <div className="NavigationLayout__navigationTop">
            {mapChildrenWithFragments<React.ComponentProps<typeof NavigationLink>>(
              navigationItemsTop,
              navigationLink => React.cloneElement(navigationLink, {collapse})
            )}
          </div>
          <div className="NavigationLayout__navigationBottom">
            {mapChildrenWithFragments<React.ComponentProps<typeof NavigationLink>>(
              navigationItemsBottom,
              navigationLink => React.cloneElement(navigationLink, {collapse})
            )}
          </div>
        </nav>
      </div>
    </aside>
    <main className="NavigationLayout__children">{children}</main>
  </div>
)

export default NavigationLayout
